import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { useUnresolvedTimeline } from "../hooks/useOcrHealthData";
import { SOURCE_COLORS } from "../sourceColors";
import { PanelCard, PanelError, PanelStatus } from "./PanelCard";

export function UnresolvedVolumeTimeline() {
  const { data, isLoading, error } = useUnresolvedTimeline(30);

  if (isLoading) return <PanelCard title="Unresolved Volume (last 30d)"><PanelStatus>Loading…</PanelStatus></PanelCard>;
  if (error) return <PanelCard title="Unresolved Volume (last 30d)"><PanelError>Couldn't load — {error}</PanelError></PanelCard>;
  if (!data || data.points.length === 0) {
    return (
      <PanelCard title="Unresolved Volume (last 30d)">
        <PanelStatus>No data</PanelStatus>
      </PanelCard>
    );
  }

  return (
    <PanelCard title="Unresolved Volume (last 30d)">
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={data.points}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="day" fontSize={11} />
          <YAxis fontSize={11} allowDecimals={false} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="unresolvedCount"
            stroke={SOURCE_COLORS.Unresolved}
            strokeWidth={2}
            dot={false}
            name="Unresolved"
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </PanelCard>
  );
}
